import { render, staticRenderFns } from "./ExpansionSection.vue?vue&type=template&id=0fc9d506"
import script from "./ExpansionSection.vue?vue&type=script&lang=ts"
export * from "./ExpansionSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports